import React from 'react';
import { useTranslation } from 'react-i18next';

function coalObservationWithoutCheckbox(i, o, tab, campo, firstElement, t, i18n) {
    return(
        <div className='row' key={i}>
            {
                firstElement == o.fields_id &&
                (
                    <div className='mt-1 row'>
                        <hr className="bg-gray-600 opacity-2" />
                        <div className='col w-50'>
                            <p>{t(tab['name_' + i18n.language])}:</p>
                        </div>
                    </div>
                )
            }
            <div className='col-4'>
                <p>{campo['name_' + i18n.language]}</p>
            </div>
            <div className='col'>
                <p className='ms-1'>{o.text}</p>
            </div>
        </div>
    )
}

export default function CoalSpecifications({ selectedCoal, fieldList, showWrongValues = false }) {
    const { t, i18n } = useTranslation();

    return (
        <>
            {
                fieldList.map((tab, id, tabList) => {
                    let firstElement = 0;
                    let aba = selectedCoal.espec.find(element => element.id == tab.id);
                    if(aba){
                        return(
                            <div key={id}>
                                <hr className="bg-gray-600 opacity-2" />
                                <div className='mt-1 row'>
                                    <div className='col w-50'>
                                        <p>{t(aba.tab)}:</p>
                                    </div>
                                </div>
                                {
                                    aba.fields.map((f, ind, elements) => {
                                        return(
                                            <div key={ind} className='row'>
                                                { // Observacao com checkbox (antes das checkboxes)
                                                    selectedCoal.observations.length > 0 &&
                                                    (
                                                        selectedCoal.observations.map((o, i) => {
                                                            if(o.fields_id == f.id - 1 && o.fields_id == tab.id + 1){
                                                                let campo = fieldList[id].children.find(element2 => element2.id == o.fields_id);
                                                                if(campo && o.text != ''){
                                                                    return(
                                                                        <div className='row' key={i}>
                                                                            <div className='col-4'>
                                                                                <p>{campo['name_' + i18n.language]}</p>
                                                                            </div>
                                                                            <div className='col'>
                                                                                <p className='ms-2 ps-1'>{o.text}</p>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            }
                                                        })
                                                    )
                                                }
                                                <div className='col-4'>
                                                    <p>{t(f.name)}</p>
                                                </div>
                                                <div className='col'>
                                                    {
                                                        f.values.length > 0 && (
                                                            f.values.map((v, index)=>{
                                                                return(
                                                                    <p key={index} className='m-1'>{v.name}</p>
                                                                )
                                                            })
                                                        )
                                                    }
                                                    {
                                                        showWrongValues && f.wrongValues?.length > 0 && (
                                                            f.wrongValues.map((va, indexx)=>{
                                                                return(
                                                                    <p key={indexx} className='m-1'><del>{va.name}</del></p>
                                                                )
                                                            })
                                                        )
                                                    }
                                                </div>
                                                { // Observacao com checkbox (depois das checkboxes)
                                                    selectedCoal.observations.length > 0 &&
                                                    (
                                                        selectedCoal.observations.map((o, i) => {
                                                            if((elements[ind + 1] && o.fields_id > f.id && o.fields_id < elements[ind + 1].id) ||
                                                                (ind == elements.length - 1 && o.fields_id > f.id && o.fields_id < tabList[id + 1].id)){

                                                                let campo = fieldList[id].children.find(element2 => element2.id == o.fields_id);

                                                                if(!campo){
                                                                    campo = fieldList[id].children.find(element => element.id == f.id)
                                                                        .children.find(element2 => element2.id == o.fields_id)
                                                                }

                                                                if(!campo){
                                                                    f.values.map((v, index) => {
                                                                        let auxCampo = fieldList[id].children.find(element => element.id == f.id)
                                                                                .children.find(element2 => element2.id == v.id);
                                                                        if(auxCampo && auxCampo.children){
                                                                            campo = auxCampo.children.find(element3 => element3.id == o.fields_id);
                                                                        }
                                                                    })
                                                                }

                                                                if(campo && o.text != ''){
                                                                    return(
                                                                        <div className='row' key={i}>
                                                                            <div className='col-4'>
                                                                                <p>{campo['name_' + i18n.language]}</p>
                                                                            </div>
                                                                            <div className='col'>
                                                                                <p className='ms-2 ps-1'>{o.text}</p>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            }
                                                        })
                                                    )
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                    else{
                        return(
                            <div key={id}>
                                { // Observacao sem checkbox
                                    selectedCoal.observations.length > 0 &&
                                    (
                                        selectedCoal.observations.map((o, i) => {
                                            let campo = tab.children.find(element => element.id == o.fields_id);

                                            if(campo){
                                                if(o.text != ''){
                                                    if(firstElement == 0) { firstElement = o.fields_id }
                                                    return coalObservationWithoutCheckbox(i, o, tab, campo, firstElement, t, i18n)
                                                }
                                            } else {
                                                return tab.children.map((element, j) => {
                                                    if(element.children){
                                                        campo = element.children.find(element2 => element2.id == o.fields_id);
                                                        if(campo){
                                                            if(o.text != ''){
                                                                if(firstElement == 0) { firstElement = o.fields_id }
                                                                return coalObservationWithoutCheckbox(i, o, tab, campo, firstElement, t, i18n)
                                                            }
                                                        } else {
                                                           return element.children.map((element2, k) => {
                                                                if(element2.children){
                                                                    campo = element2.children.find(element3 => element3.id == o.fields_id);
                                                                    if(campo){
                                                                        if(o.text != ''){
                                                                            if(firstElement == 0) { firstElement = o.fields_id }
                                                                            return coalObservationWithoutCheckbox(i, o, tab, campo, firstElement, t, i18n)
                                                                        }
                                                                    }
                                                                }
                                                            })
                                                        }
                                                    }
                                                });
                                            }
                                        })
                                    )
                                }
                            </div>
                        )
                    }
                })
            }
        </>
    )
}